import { useState } from "react";
import { Check, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const SCHOOL = "SMK Pembangunan Kota Ternate";

export const normalizePhone = (p = "") => {
  const d = String(p).replace(/\D/g, "");
  if (!d) return "";
  if (d.startsWith("62")) return d;
  if (d.startsWith("0")) return `62${d.slice(1)}`;
  return d.startsWith("8") ? `62${d}` : d;
};

const fmtDate = (d) => new Date(`${d}T00:00:00`).toLocaleDateString("id-ID", { weekday: "long", day: "numeric", month: "long", year: "numeric" });

export const buildMessage = (r, target) => {
  const head = target === "parent"
    ? `Yth. Bapak/Ibu ${r.parent_name || "Orang Tua/Wali"} dari *${r.student_name}*,`
    : `Halo *${r.student_name}*,`;
  return [
    `*${SCHOOL}*`, "_Catatan Disiplin SIDEPAS_", "", head, "berikut catatan disiplin yang tercatat di sekolah:", "",
    `Nama   : ${r.student_name}`, `Kelas  : ${r.class_name}`, `Tanggal: ${fmtDate(r.date)}`,
    `Catatan: *${r.category}* (${r.kind})`, `Uraian : ${r.description || "-"}`, "",
    r.kind === "Positif" ? "Terima kasih atas kedisiplinannya. Pertahankan!" : "Mohon perhatian dan pembinaannya. Terima kasih.",
  ].join("\n");
};

const WaButton = ({ r, target, recordId, prefix, onSent }) => {
  const phone = normalizePhone(target === "parent" ? r.parent_phone : r.phone);
  const [sent, setSent] = useState(Boolean(target === "parent" ? r.wa_parent_at : r.wa_student_at));
  const label = target === "parent" ? "WA Wali" : "WA Siswa";
  const send = (e) => {
    e.stopPropagation();
    if (!phone) { toast.error(`Nomor WhatsApp ${target === "parent" ? "orang tua/wali" : "siswa"} belum diisi di Data Siswa`); return; }
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(buildMessage(r, target))}`, "_blank", "noopener");
    if (recordId) api(`/discipline/${recordId}/wa-log`, { method: "POST", body: JSON.stringify({ target }) }).then(() => { setSent(true); onSent?.(); }).catch(() => {});
  };
  return (
    <button type="button" className={`mini-btn wa ${sent ? "sent" : ""} ${phone ? "" : "no-phone"}`} onClick={send} title={phone ? `Kirim ke +${phone}` : "Nomor belum diisi"} data-testid={`${prefix || "wa"}-${target}-button-${recordId || r.id}`}>
      {sent ? <Check size={13} /> : <MessageCircle size={13} />} {label}
    </button>
  );
};

export const WaButtons = ({ r, recordId, prefix, onSent }) => {
  if (r.student_deleted) return null;
  const id = recordId || r.id;
  return <span className="row-actions"><WaButton key={`s-${id}-${r.wa_student_at || ""}`} r={r} target="student" recordId={id} prefix={prefix} onSent={onSent} /><WaButton key={`p-${id}-${r.wa_parent_at || ""}`} r={r} target="parent" recordId={id} prefix={prefix} onSent={onSent} /></span>;
};
